// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_headline___FXPmN {
  font-weight: 500;
  font-size: 1rem;
  padding-bottom: 4px;
}
.theme--light .InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_headline___FXPmN {
  color: #212121;
}
.theme--dark .InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_headline___FXPmN {
  color: #f0f0f0;
}
.theme--light .InternalNotesModal-module_main___EtBl4 {
  background-color: #ffffff;
  color: #212121;
  border-bottom: 1px solid #dddddd;
}
.theme--dark .InternalNotesModal-module_main___EtBl4 {
  background-color: #1c1c1c;
  color: #f0f0f0;
  border-bottom: 1px solid #2f2f2f;
}
.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_content___qa4Zf {
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
}
.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_content___qa4Zf .InternalNotesModal-module_note___K0yea {
  display: flex;
  gap: 10px;
}
.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_content___qa4Zf .InternalNotesModal-module_notes___tIMXr {
  flex: 1;
}
.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_content___qa4Zf .InternalNotesModal-module_notes___tIMXr .InternalNotesModal-module_emptyNotes___mOuoV {
  color: #808080;
  text-decoration: underline;
  font-weight: 500;
  font-size: 1.2rem;
}
.InternalNotesModal-module_main___EtBl4 .InternalNotesModal-module_content___qa4Zf .InternalNotesModal-module_options___zVQoS {
  display: flex;
  align-items: end;
}

.InternalNotesModal-module_loaderWrapper___BROOi {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 450px;
}

.InternalNotesModal-module_inModal___yJKt4 {
  padding-top: 12px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_wrapper___bYeRF {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_wrapperCentered___nIp8q {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  padding: 0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_eventSiteWrapper___In2nj {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_wrapperLeft___MZtWV {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 48px;
  overflow: visible;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_wrapperLeft___MZtWV[data-space-between=true] {
  justify-content: space-between;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_label___XES6k {
  font-weight: 500;
  font-size: 1.3rem;
  display: block;
  margin-bottom: 6px;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_label___XES6k {
  color: #888888;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_label___XES6k {
  color: #a3a3a3;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_vBox___aPSpg {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
  padding: 4px 0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_vBox___aPSpg[data-has-right-divider=true] {
  padding-right: 24px;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_vBox___aPSpg[data-has-right-divider=true] {
  border-right: 1px solid #dddddd;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_vBox___aPSpg[data-has-right-divider=true] {
  border-right: 1px solid #2f2f2f;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_vBox___aPSpg[data-small=true] {
  max-width: 340px;
  min-width: 300px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-is-divider=true] {
  padding-bottom: 18px;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-is-divider=true] {
  border-bottom: 1px solid #dddddd;
  width: 100%;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-is-divider=true] {
  border-bottom: 1px solid #2f2f2f;
  width: 100%;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-padding-right=true] {
  padding-right: 16px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-capped-height=true] {
  max-height: 320px;
  height: 320px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_inContent___KKOPn[data-is-scrollable=true] {
  overflow: auto;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_subHeader___BKxG2 {
  font-weight: 600;
  font-size: 1.6rem;
  padding: 0;
  color: var(--sectionHeadlineText);
  letter-spacing: 0.2px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_topLabel___YZBgy {
  font-size: 1.3rem;
  font-weight: 500;
  margin-bottom: 6px;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_topLabel___YZBgy {
  color: #888888;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_topLabel___YZBgy {
  color: #a3a3a3;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_topLabel___YZBgy[data-inline=true] {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_description___zrXpK {
  font-size: 1.2rem;
  padding-bottom: 8px;
  font-weight: 500;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_description___zrXpK {
  color: #888888;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_description___zrXpK {
  color: #a3a3a3;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO {
  width: 100%;
  border-radius: 6px;
  min-height: 180px;
  padding: 10px 12px;
  font-size: 1.3rem;
  line-height: 1.5;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO::placeholder {
  color: #888888;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO::placeholder {
  color: #a3a3a3;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO:focus {
  outline: none;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO:focus {
  border-color: #212121;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_textArea___nX6sO:focus {
  border-color: #f0f0f0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL {
  width: 100%;
  border-radius: 6px;
  min-height: 70px;
  padding: 10px 12px;
  font-size: 1.3rem;
  line-height: 1.5;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL::placeholder {
  color: #888888;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL::placeholder {
  color: #a3a3a3;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL:focus {
  outline: none;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL:focus {
  border-color: #212121;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_minimalTextArea___KX7QL:focus {
  border-color: #f0f0f0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_divider___x1cTa[data-is-horizontal=true] {
  margin: 4px 0;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_divider___x1cTa[data-is-horizontal=true] {
  border-bottom: 1px solid #dddddd;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_divider___x1cTa[data-is-horizontal=true] {
  border-bottom: 1px solid #2f2f2f;
}
.theme--light .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_divider___x1cTa[data-is-vertical=true] {
  border-right: 1px solid #dddddd;
}
.theme--dark .InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_divider___x1cTa[data-is-vertical=true] {
  border-right: 1px solid #2f2f2f;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_fieldGroup___qQjbW {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_fieldGroup___qQjbW[data-grow=seats] {
  flex: 1.4;
  min-width: 220px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_fieldGroup___qQjbW[data-grow=default] {
  min-width: 180px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_fieldGroup___qQjbW[data-grow=masked] {
  flex: 1;
  min-width: 110px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_fieldGroup___qQjbW[data-grow=event-site] {
  flex: 1;
  min-width: 220px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_maskedToggle___zqRpe {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  flex-shrink: 0;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_accountsList___whoEl {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.InternalNotesModal-module_inModal___yJKt4 .InternalNotesModal-module_addAccountWrapper___sTH8z {
  display: flex;
}

.InternalNotesModal-module_accountContainer___gqkTf {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-end;
  flex: 1;
  flex-wrap: wrap;
}
.InternalNotesModal-module_accountContainer___gqkTf a {
  font-size: 1.2rem;
  cursor: pointer;
}
.InternalNotesModal-module_accountContainer___gqkTf .InternalNotesModal-module_field___HXEmB {
  flex: 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
}
.InternalNotesModal-module_accountContainer___gqkTf .InternalNotesModal-module_field___HXEmB[data-grow=seats] {
  flex: 1.4;
  min-width: 220px;
}
.InternalNotesModal-module_accountContainer___gqkTf .InternalNotesModal-module_passwordRow___GZzyd {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.InternalNotesModal-module_buttonsContainer___YZKdj {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 20px;
}

.InternalNotesModal-module_flagToggles___kosd8 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.InternalNotesModal-module_flagToggle___qucj5 {
  border-radius: 6px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  font-size: 1.1rem;
  cursor: pointer;
  white-space: nowrap;
}
.theme--light .InternalNotesModal-module_flagToggle___qucj5 {
  border: 1px solid #dddddd;
  background-color: #ffffff;
}
.theme--dark .InternalNotesModal-module_flagToggle___qucj5 {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
}

.InternalNotesModal-module_singleAccountContainer___YV2dE {
  border-radius: 8px;
  padding: 14px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-end;
  transition: border-color 0.15s ease;
}
.theme--light .InternalNotesModal-module_singleAccountContainer___YV2dE {
  background-color: #ffffff;
  border: 1px solid #dddddd;
}
.theme--dark .InternalNotesModal-module_singleAccountContainer___YV2dE {
  background-color: #1c1c1c;
  border: 1px solid #2f2f2f;
}
.theme--light .InternalNotesModal-module_singleAccountContainer___YV2dE:hover {
  border-color: #888888;
}
.theme--dark .InternalNotesModal-module_singleAccountContainer___YV2dE:hover {
  border-color: #a3a3a3;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/internalNotes/internalNotesModal/InternalNotesModal.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAfC;EAKC,gBAAA;EACA,eAAA;EACA,mBAAA;AAcF;ADgFE;ECnGC,cAAA;AAsBH;AD6EE;ECnGC,cAAA;AAyBH;AD0EE;EC1FA,yBAAA;EACA,cAAA;EACA,gCAAA;AAmBF;ADqEE;EC1FA,yBAAA;EACA,cAAA;EACA,gCAAA;AAwBF;AArBC;EACC,aAAA;EACA,SAAA;EAuBA,oBAAA;AACF;AAtBE;EACC,aAAA;EACA,SAAA;AAwBH;AArBE;EACC,OAAA;AAuBH;AArBG;EACC,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAuBJ;AAnBE;EACC,aAAA;EACA,gBAAA;AAqBH;;AAdA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAiBD;;AAdA;EACC,iBAAA;AAiBD;AAfC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAiBF;AAdC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AAgBF;AAbC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AAeF;AAZC;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAcF;AAZE;EACC,8BAAA;AAcH;AAVC;EACC,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAYF;ADNE;ECHC,cAAA;AAYH;ADTE;ECHC,cAAA;AAeH;AAXC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;AAaF;AAXE;EAIC,mBAAA;AAUH;ADtBE;ECUE,+BAAA;AAeJ;ADzBE;ECUE,+BAAA;AAkBJ;AAbE;EACC,gBAAA;EACA,gBAAA;AAeH;AAXC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAaF;AAXE;EAKC,oBAAA;AASH;ADzCE;EC6BE,gCAAA;EACA,WAAA;AAeJ;AD7CE;EC6BE,gCAAA;EACA,WAAA;AAmBJ;AAdE;EACC,mBAAA;AAgBH;AAbE;EACC,iBAAA;EACA,aAAA;AAeH;AAZE;EACC,cAAA;AAcH;AAVC;EACC,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,iCAAA;EACA,qBAAA;AAYF;AATC;EACC,iBAAA;EACA,gBAAA;EACA,kBAAA;AAWF;ADvEE;EC+DC,cAAA;AAWH;AD1EE;EC+DC,cAAA;AAcH;AAXE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAaH;AATC;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;AAWF;ADvFE;EC8EC,cAAA;AAYH;AD1FE;EC8EC,cAAA;AAeH;AAXC;EAWC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0DAAA;AAGF;ADvGE;ECoFC,yBAAA;EACA,yBAAA;EACA,cAAA;AAsBH;AApBG;EACC,cAAA;AAsBJ;AD/GE;ECoFC,yBAAA;EACA,yBAAA;EACA,cAAA;AA8BH;AA5BG;EACC,cAAA;AA8BJ;AAjBE;EACC,aAAA;AAmBH;AD1HE;ECyGE,qBAAA;AAoBJ;AD7HE;ECyGE,qBAAA;AAuBJ;AAlBC;EAWC,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0DAAA;AAUF;AD1IE;ECgHC,yBAAA;EACA,yBAAA;EACA,cAAA;AA6BH;AA3BG;EACC,cAAA;AA6BJ;ADlJE;ECgHC,yBAAA;EACA,yBAAA;EACA,cAAA;AAqCH;AAnCG;EACC,cAAA;AAqCJ;AAxBE;EACC,aAAA;AA0BH;AD7JE;ECqIE,qBAAA;AA2BJ;ADhKE;ECqIE,qBAAA;AA8BJ;AAxBE;EAIC,aAAA;AAuBH;ADtKE;EC6IE,gCAAA;AA4BJ;ADzKE;EC6IE,gCAAA;AA+BJ;AD5KE;ECoJE,+BAAA;AA2BJ;AD/KE;ECoJE,+BAAA;AA8BJ;AAzBC;EACC,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AA2BF;AAzBE;EACC,SAAA;EACA,gBAAA;AA2BH;AAxBE;EACC,gBAAA;AA0BH;AAvBE;EACC,OAAA;EACA,gBAAA;AAyBH;AAtBE;EACC,OAAA;EACA,gBAAA;AAwBH;AApBC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAsBF;AAnBC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAqBF;AAlBC;EACC,aAAA;AAoBF;;AAhBA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,OAAA;EACA,eAAA;AAmBD;AAjBC;EACC,iBAAA;EACA,eAAA;AAmBF;AAhBC;EACC,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAkBF;AAhBE;EACC,SAAA;EACA,gBAAA;AAkBH;AAdC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AAgBF;;AAZA;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAeD;;AAZA;EACC,aAAA;EACA,eAAA;EACA,QAAA;AAeD;;AAZA;EAMC,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAUD;ADzQE;ECqPA,yBAAA;EACA,yBAAA;AAuBF;AD7QE;ECqPA,yBAAA;EACA,yBAAA;AA2BF;;AAfA;EAMC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,mCAAA;AAaD;AD3RE;ECoQA,yBAAA;EACA,yBAAA;AA0BF;AD/RE;ECoQA,yBAAA;EACA,yBAAA;AA8BF;ADnSE;ECkRC,qBAAA;AAoBH;ADtSE;ECkRC,qBAAA;AAuBH","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.main .headline {\n  font-weight: 500;\n  font-size: 1rem;\n  padding-bottom: 4px;\n}\n:global(.theme--light) .main .headline {\n  color: #212121;\n}\n:global(.theme--dark) .main .headline {\n  color: #f0f0f0;\n}\n:global(.theme--light) .main {\n  background-color: #ffffff;\n  color: #212121;\n  border-bottom: 1px solid #dddddd;\n}\n:global(.theme--dark) .main {\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n  border-bottom: 1px solid #2f2f2f;\n}\n.main .content {\n  display: flex;\n  gap: 10px;\n  padding-bottom: 10px;\n}\n.main .content .note {\n  display: flex;\n  gap: 10px;\n}\n.main .content .notes {\n  flex: 1;\n}\n.main .content .notes .emptyNotes {\n  color: #808080;\n  text-decoration: underline;\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n.main .content .options {\n  display: flex;\n  align-items: end;\n}\n\n.loaderWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 450px;\n}\n\n.inModal {\n  padding-top: 12px;\n}\n.inModal .wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 24px;\n}\n.inModal .wrapperCentered {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 0;\n}\n.inModal .eventSiteWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.inModal .wrapperLeft {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 48px;\n  overflow: visible;\n}\n.inModal .wrapperLeft[data-space-between=true] {\n  justify-content: space-between;\n}\n.inModal .label {\n  font-weight: 500;\n  font-size: 1.3rem;\n  display: block;\n  margin-bottom: 6px;\n}\n:global(.theme--light) .inModal .label {\n  color: #888888;\n}\n:global(.theme--dark) .inModal .label {\n  color: #a3a3a3;\n}\n.inModal .vBox {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 18px;\n  padding: 4px 0;\n}\n.inModal .vBox[data-has-right-divider=true] {\n  padding-right: 24px;\n}\n:global(.theme--light) .inModal .vBox[data-has-right-divider=true] {\n  border-right: 1px solid #dddddd;\n}\n:global(.theme--dark) .inModal .vBox[data-has-right-divider=true] {\n  border-right: 1px solid #2f2f2f;\n}\n.inModal .vBox[data-small=true] {\n  max-width: 340px;\n  min-width: 300px;\n}\n.inModal .inContent {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.inModal .inContent[data-is-divider=true] {\n  padding-bottom: 18px;\n}\n:global(.theme--light) .inModal .inContent[data-is-divider=true] {\n  border-bottom: 1px solid #dddddd;\n  width: 100%;\n}\n:global(.theme--dark) .inModal .inContent[data-is-divider=true] {\n  border-bottom: 1px solid #2f2f2f;\n  width: 100%;\n}\n.inModal .inContent[data-padding-right=true] {\n  padding-right: 16px;\n}\n.inModal .inContent[data-capped-height=true] {\n  max-height: 320px;\n  height: 320px;\n}\n.inModal .inContent[data-is-scrollable=true] {\n  overflow: auto;\n}\n.inModal .subHeader {\n  font-weight: 600;\n  font-size: 1.6rem;\n  padding: 0;\n  color: var(--sectionHeadlineText);\n  letter-spacing: 0.2px;\n}\n.inModal .topLabel {\n  font-size: 1.3rem;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n:global(.theme--light) .inModal .topLabel {\n  color: #888888;\n}\n:global(.theme--dark) .inModal .topLabel {\n  color: #a3a3a3;\n}\n.inModal .topLabel[data-inline=true] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.inModal .description {\n  font-size: 1.2rem;\n  padding-bottom: 8px;\n  font-weight: 500;\n}\n:global(.theme--light) .inModal .description {\n  color: #888888;\n}\n:global(.theme--dark) .inModal .description {\n  color: #a3a3a3;\n}\n.inModal .textArea {\n  width: 100%;\n  border-radius: 6px;\n  min-height: 180px;\n  padding: 10px 12px;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  font-family: inherit;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n:global(.theme--light) .inModal .textArea {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--light) .inModal .textArea::placeholder {\n  color: #888888;\n}\n:global(.theme--dark) .inModal .textArea {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n:global(.theme--dark) .inModal .textArea::placeholder {\n  color: #a3a3a3;\n}\n.inModal .textArea:focus {\n  outline: none;\n}\n:global(.theme--light) .inModal .textArea:focus {\n  border-color: #212121;\n}\n:global(.theme--dark) .inModal .textArea:focus {\n  border-color: #f0f0f0;\n}\n.inModal .minimalTextArea {\n  width: 100%;\n  border-radius: 6px;\n  min-height: 70px;\n  padding: 10px 12px;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  font-family: inherit;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n:global(.theme--light) .inModal .minimalTextArea {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--light) .inModal .minimalTextArea::placeholder {\n  color: #888888;\n}\n:global(.theme--dark) .inModal .minimalTextArea {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n:global(.theme--dark) .inModal .minimalTextArea::placeholder {\n  color: #a3a3a3;\n}\n.inModal .minimalTextArea:focus {\n  outline: none;\n}\n:global(.theme--light) .inModal .minimalTextArea:focus {\n  border-color: #212121;\n}\n:global(.theme--dark) .inModal .minimalTextArea:focus {\n  border-color: #f0f0f0;\n}\n.inModal .divider[data-is-horizontal=true] {\n  margin: 4px 0;\n}\n:global(.theme--light) .inModal .divider[data-is-horizontal=true] {\n  border-bottom: 1px solid #dddddd;\n}\n:global(.theme--dark) .inModal .divider[data-is-horizontal=true] {\n  border-bottom: 1px solid #2f2f2f;\n}\n:global(.theme--light) .inModal .divider[data-is-vertical=true] {\n  border-right: 1px solid #dddddd;\n}\n:global(.theme--dark) .inModal .divider[data-is-vertical=true] {\n  border-right: 1px solid #2f2f2f;\n}\n.inModal .fieldGroup {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n.inModal .fieldGroup[data-grow=seats] {\n  flex: 1.4;\n  min-width: 220px;\n}\n.inModal .fieldGroup[data-grow=default] {\n  min-width: 180px;\n}\n.inModal .fieldGroup[data-grow=masked] {\n  flex: 1;\n  min-width: 110px;\n}\n.inModal .fieldGroup[data-grow=event-site] {\n  flex: 1;\n  min-width: 220px;\n}\n.inModal .maskedToggle {\n  display: flex;\n  align-items: center;\n  padding-bottom: 6px;\n  flex-shrink: 0;\n}\n.inModal .accountsList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.inModal .addAccountWrapper {\n  display: flex;\n}\n\n.accountContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-end;\n  flex: 1;\n  flex-wrap: wrap;\n}\n.accountContainer a {\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n.accountContainer .field {\n  flex: 1;\n  min-width: 160px;\n  display: flex;\n  flex-direction: column;\n}\n.accountContainer .field[data-grow=seats] {\n  flex: 1.4;\n  min-width: 220px;\n}\n.accountContainer .passwordRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 0 20px;\n}\n\n.flagToggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.flagToggle {\n  border-radius: 6px;\n  padding: 6px 10px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.1rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n:global(.theme--light) .flagToggle {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n}\n:global(.theme--dark) .flagToggle {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n}\n\n.singleAccountContainer {\n  border-radius: 8px;\n  padding: 14px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-end;\n  transition: border-color 0.15s ease;\n}\n:global(.theme--light) .singleAccountContainer {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .singleAccountContainer {\n  background-color: #1c1c1c;\n  border: 1px solid #2f2f2f;\n}\n:global(.theme--light) .singleAccountContainer:hover {\n  border-color: #888888;\n}\n:global(.theme--dark) .singleAccountContainer:hover {\n  border-color: #a3a3a3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `InternalNotesModal-module_main___EtBl4`,
	"headline": `InternalNotesModal-module_headline___FXPmN`,
	"content": `InternalNotesModal-module_content___qa4Zf`,
	"note": `InternalNotesModal-module_note___K0yea`,
	"notes": `InternalNotesModal-module_notes___tIMXr`,
	"emptyNotes": `InternalNotesModal-module_emptyNotes___mOuoV`,
	"options": `InternalNotesModal-module_options___zVQoS`,
	"loaderWrapper": `InternalNotesModal-module_loaderWrapper___BROOi`,
	"inModal": `InternalNotesModal-module_inModal___yJKt4`,
	"wrapper": `InternalNotesModal-module_wrapper___bYeRF`,
	"wrapperCentered": `InternalNotesModal-module_wrapperCentered___nIp8q`,
	"eventSiteWrapper": `InternalNotesModal-module_eventSiteWrapper___In2nj`,
	"wrapperLeft": `InternalNotesModal-module_wrapperLeft___MZtWV`,
	"label": `InternalNotesModal-module_label___XES6k`,
	"vBox": `InternalNotesModal-module_vBox___aPSpg`,
	"inContent": `InternalNotesModal-module_inContent___KKOPn`,
	"subHeader": `InternalNotesModal-module_subHeader___BKxG2`,
	"topLabel": `InternalNotesModal-module_topLabel___YZBgy`,
	"description": `InternalNotesModal-module_description___zrXpK`,
	"textArea": `InternalNotesModal-module_textArea___nX6sO`,
	"minimalTextArea": `InternalNotesModal-module_minimalTextArea___KX7QL`,
	"divider": `InternalNotesModal-module_divider___x1cTa`,
	"fieldGroup": `InternalNotesModal-module_fieldGroup___qQjbW`,
	"maskedToggle": `InternalNotesModal-module_maskedToggle___zqRpe`,
	"accountsList": `InternalNotesModal-module_accountsList___whoEl`,
	"addAccountWrapper": `InternalNotesModal-module_addAccountWrapper___sTH8z`,
	"accountContainer": `InternalNotesModal-module_accountContainer___gqkTf`,
	"field": `InternalNotesModal-module_field___HXEmB`,
	"passwordRow": `InternalNotesModal-module_passwordRow___GZzyd`,
	"buttonsContainer": `InternalNotesModal-module_buttonsContainer___YZKdj`,
	"flagToggles": `InternalNotesModal-module_flagToggles___kosd8`,
	"flagToggle": `InternalNotesModal-module_flagToggle___qucj5`,
	"singleAccountContainer": `InternalNotesModal-module_singleAccountContainer___YV2dE`
};
export default ___CSS_LOADER_EXPORT___;
